import { gql } from '@apollo/client'

export const reorderUserDrafts = gql`
  mutation ReorderUserDrafts($userDrafts: [UserDraftIndexChangeInput!]!) {
    reorderUserDrafts(userDrafts: $userDrafts)
  }
`
